<template>
  <v-dialog
    v-model="showDialog"
    persistent
    scrollable
    :disabled="isDisabled"
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
  >
    <template v-slot:activator="{ props }">
      <slot v-bind="{ props }" name="activator" />
    </template>

    <div class="vb-dialog vb-dialog-danger">
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <span>
            {{
              type === 'empty'
                ? $t('routes.recycleBin.emptyRecycleBin')
                : $t('routes.recycleBin.permanentlyDeleteSelected')
            }}
          </span>
          <v-btn icon="mdi-close" variant="text" @click="closeDialog" :disabled="inProgress" :aria-label="$t('common.close')" />
        </v-card-title>

        <v-card-text class="pt-5 scrollable">
          {{
            type === 'empty'
              ? $t('routes.recycleBin.confirmEmptyRecycleBin')
              : $t('routes.recycleBin.confirmDeleteSelected')
          }}
          <div v-if="errorMessage" class="bg-error">
            {{ errorMessage }}
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn elevation="0" :disabled="inProgress" @click="$emit('confirm')" class="bg-red-darken-3">
            {{ $t('common.confirm') }}
          </v-btn>
          <v-btn elevation="0" :disabled="inProgress" @click="closeDialog" class="btnCancel">
            {{ $t('common.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
export default {
  emits: ['confirm', 'cancel', 'update:modelValue'],
  name: "RecycleBinConfirmationDialog",
  data: function () {
    return {};
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    isShowingDialog: {
      type: Boolean,
      required: false,
    },
    type: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      required: true,
    },
    inProgress: {
      type: Boolean,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    isShowingDialog(val) {
      if (!val) {
        this.showDialog = false;
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('cancel');
      this.showDialog = false;
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  }
}
</script>

<style scoped>
</style>
